import { Link } from "react-router-dom"
import "../css/findid.css"

export default function FindId2({ idMasked, phoneNumber, onReset }) {
    return (
        <>
            <div className="FindId_Header">
                <p>아이디 찾기</p>
            </div>
            <div className="FindId_Mid">
                <p>아이디 찾기 결과</p>
                <p>귀하의 아이디는 다음과 같습니다</p>
            </div>
            <div className="FindId_Id">
                <p>{idMasked ?? "조회된 아이디가 없습니다."}</p>
            </div>
            <div className="FindId_button">
                <Link to="/"><button>로그인 하러 가기</button></Link>
            </div>
        </>
    )
}